<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" style="position: relative; height: 100%; width: 100%; display:table;">
    <div style=" height: 100%; position: absolute; width: 100%;display:inline-table" class="mt-3 pr-0 mr-0">
      <table border="0" style="height:100%;width:100%">
        <tr>
          <td style="">
            <div class="mb-3 mt-3" v-show="infoexpanded == true">              
              <div class="col px-0">
                <input-text type="text" required @change="onChange($event)" id="procedurename" name="procedurename" v-bind:placeholder="$t('enter_procedure_name')" v-model="procedure.ProcedureName" style="font-size:18px;"></input-text>
              </div>
            </div>
            <div class="row mt-3" v-show="infoexpanded == true">
              <div class="col-12 custom-form-label">
                {{$t('description')}}               
              </div>
            </div>
            <div class="row mt-1" v-show="descriptionexpanded == true && infoexpanded == true">
              <div class="col-12">
                <textarea @change="onChange($event)" class="form-control" v-model="procedure.Description" v-bind:placeholder="$t('enter_description')" style="border:1px solid #ccc !important; padding:5px;"></textarea>
              </div>
            </div>
            <div class="row mt-3" v-show="infoexpanded == true">
              <div class="col-12 custom-form-label">
                {{$t('success_message')}}
              </div>
            </div>
            <div class="row mt-1" v-show="infoexpanded == true">
              <div class="col-12">
                <textarea @change="onChange($event)" class="form-control" v-model="procedure.SuccessMessage" v-bind:placeholder="$t('success_message')" style="border:1px solid #ccc !important; padding:5px;"></textarea>
              </div>
            </div>            
            <div class="row mt-3">
              <div class="col-12 custom-form-label">
                {{$store.translate('optional_elements')}}
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td valign="top" style="height:100%;padding:0px;">

            <div class="container-fluid p-0">
              <div class="row p-0 m-0" style="position:relative;">
                <div style="position:relative;" class="col-12 p-0">
                  <div id="nestedContainer" class="mt-1 pl-2 py-4" style="width: 100%; overflow-y: visible !important; overflow-x: auto !important; border: 1px dashed #ccc; position: relative; z-index: 1">
                    <nested-property ref="nestedproperty" class="base-item" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="itemSettings" v-bind:displaydropmessage="true" style="z-index:10000;" />
                  </div>
                </div>
                <div style="position:relative;" class="col-12 p-0 my-3">
                  <button type="button" style="width:100%;" class="btn btn-light text-center" @click="openSelector">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <element-selector ref="selector" @selected_element="addedElementFromSelector"></element-selector>
    <upload-container ref="uploadComponent" @change="urlChange2"></upload-container>
    <procedure-property-settings ref="propertySettings"></procedure-property-settings>
  </div>
</template>

<script>

  var urlerrors = [];
  var selectedElement = {};
  var internalurl = "";
  var timeEst = 0;
  import UploadService from "../services/UploadFilesService";
  import ModalEmpty from "../modals/modal-empty.vue";
  import TextInput from "../form-components/input-text.vue";
  //import UploadSelector2 from "../upload/upload-file-selector2.vue";
  import UploadContainer from "../upload/upload-container.vue";
  import draggable from "vuedraggable";
  import ProcedurePropertySettings from '../procedure/procedure-property-settings.vue'
  import procedureName from '../procedure/procedure-name.vue'


  var thisProcedure = {};

  export default {
    name: "task-editmenu",
    display: "Nested (v-model & vuex)",
    order: 16,
    components: {
      procedureName,
      draggable,
      //UploadSelector2,
      ModalEmpty,
      TextInput,
      ProcedurePropertySettings,
      UploadContainer,
      UploadService,

    },
    props: {

    },
    data() {
      return {
        procedure: {
          ProcedureId: -1,
          ProcedureName: "",
          ProcedureScheduleName: "",
          ScheduleWorkNote: "",
          Description: "",
          Elements: [],
          EstimatedTime: 0,
          CategoryId: -1,
          Priority: 0,
          Status: 0,
          NewCategoryName: null,
          Locked: false,
          Private: false,
          Settings: {
            Property: {
              EnablePrivateChat: "True"
            }
          },
          IsTask: true
        },
        internalurl,
        selectedElement,
        urlerrors,
        timeEst,
        hours: 0,
        minutes: 0,
        elements: [],
        descriptionexpanded: true,
        infoexpanded: true,        
        //fileName: '',
      };
    },
    computed: {      
      Elements: {
        get() {
          return this.elements;
        },
        set(value) {
          this.elements = value;
        }
      }
    },
    methods: {
      openSelector() {
        this.$refs.selector.open();
      },
      addedElementFromSelector(element) {
        this.addingFromMenuClick(element)
      },
      removeProcImg() {
        this.internalurl = null;
        this.selectedElement.Url = null;
        this.procedure.Url = null;
        this.procedure.ProcUrlElement.Url = null;
        this.procedure.ProcUrlElement.Text = '';
        this.$store.markAsChanged();
      },
      onProcImgLoad() {
        //var url = this.procedure.Url;
        //if (url != null) {
        //  var id = "";
        //  var urlParts = url.split('?');
        //  if (urlParts.length > 1) {
        //    var urlSegments = urlParts[1].split('&');
        //    id = urlSegments[0].split('=')[1];
        //    UploadService.getFileInfo(id, this.showuserviews).then((response) => {
        //      if (this.procedure.ProcUrlElement != null) {
        //        this.procedure.ProcUrlElement.Text = response.data.FileName;
        //      }
        //    });
        //  }
        //}

      },    
     
      onChange() {
        this.$store.markAsChanged();
      },
      async setProcedure(val) {
        this.procedure = val;
        this.$forceUpdate();
      },
      async loadElements(elements) {
        this.$refs.nestedproperty.setElements(elements);
        //this.$forceUpdate();
      },     
      urlValidationError(errors) {
        this.urlerrors = errors;
      },
      urlChange() {
        this.internalurl = null;
      },
      urlChange2(val, name, settings) {
        this.internalurl = val;
        this.selectedElement.Url = this.internalurl;
        //Vue.set(this.selectedElement, "Url", this.internalurl);
        //Vue.set(this, "internalurl", this.internalurl);
        //this.internalurl

        if (this.selectedElement == this.procedure.ProcUrlElement) {

          //var tmp = this.procedure;
          //tmp.Url = this.internalurl;
          Vue.set(this.procedure, "Url", this.internalurl);
          //procedure = tmp;
        }
        this.$forceUpdate();
        this.$store.markAsChanged();
      },
      saving() {
        if (this.internalurl != null) {
          this.selectedElement.Url = this.internalurl;
        }
        else {

        }

        this.internalurl = null;
        this.$refs.uploadComponent.clear();
        this.$refs.uploadComponent.close();
      },
      itemSettings(element) {
        this.$refs.propertySettings.setProperty(element);
        this.$refs.propertySettings.open();
      },
      clickItem(element) {
        this.selectedElement = element;
        this.internalurl = null;
        this.$refs.uploadComponent.clear();
        if (typeof (element.Url) != 'undefined' && element.Url != null && element.Url != "") {

          this.$refs.uploadComponent.showFile(element.Url, element.Text);
        }
        //alert(JSON.stringify(element))
        this.$refs.uploadComponent.open();

      },
      deleteChildren(elements) {
        for (var i = 0; i < elements.length; i++) {
          elements[i].IsDeleted = true;
          this.deleteChildren(elements[i].Elements);
        }
      },

      deleteItem(id, elements) {
        var isRoot = false;
        if (elements == null || typeof elements == "undefined") {
          elements = this.procedure.Elements;
          isRoot = true;
        }

        for (var i = 0; i < elements.length; i++) {
          if (elements[i].Id == id) {
            elements[i].IsDeleted = true;
            this.deleteChildren(elements[i].Elements);
          }
          else {
            this.deleteItem(id, elements[i].Elements);
          }
        }


        if (isRoot) {
          var proc = this.procedure;
          this.procedure = proc;
          Vue.set(proc, "Elements", elements);
          this.$forceUpdate();
          this.$store.markAsChanged();
        }

      },
      //handleRefresh(val) {
      //  this.timeEst = parseFloat(this.procedure.EstimatedTimeTimeTicks) / 36000000000;
      //  this.$forceUpdate();
      //  this.setTimeControlValue();
      //},

      //setTimeControlValue() {
      //  this.minutes = 0;
      //  this.hours = parseInt(this.timeEst);
      //  var partOfHour = this.timeEst % 1;
      //  if (partOfHour > 0)
      //    this.minutes = parseInt((partOfHour * 60));
      //},

      //changeTimeEst(val) {
      //  this.procedure.EstimatedTimeTimeTicks = val * 36000000000;
      //  var hours = parseInt(val);
      //  var partOfHour = val % 1;
      //  var label = hours + "h";
      //  if (partOfHour > 0)
      //    label += ", " + (partOfHour * 60) + "min";
      //  this.$refs.timeEstimated.label = label;

      //},
      //updateTimeEst(val) {
      //  try {
      //    var url = '/api/Procedure/UpdateEstimatedTime?procedureId=' + this.procedure.Id + '&estimatedTime=' + val;
      //    this.$http.get(url).then(async response => {
      //      //alert('doSearch8')
      //      vm.$root.$emit('doSearch');
      //    });
      //  }
      //  catch (err) {
      //    //alert('some error:' + err)
      //  }
      //},
      addingFromMenuClick(element) {
        var proc = this.procedure;
        var id = -1;
        for (var i = 0; i < element.Elements.length; i++) {
          element.Elements[i].Id = id--;
        }
        proc.Elements.push(element);
        this.procedure = proc;
        this.loadElements(proc.Elements);
      },
      quicklinkClick(element) {
        if (element.option == "qr") {
          //alert("show QR")
        }
        else if (element.option == "settings") {
          //alert("show settings")
        }
      },


    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
      this.$root.$on('procedure_add_element', this.addingFromMenuClick);

    },
    mounted() {
     

    },

    watch: {
    }
  };
</script>


<style scoped>


  /*
  .base-item {
    min-height: 100px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
    margin:auto;
    display:inline-block;
    overflow:visible;
    margin-top: 5px !important;
    width:initial !important;
    min-width:100%;
  }
  */

  .drag_container:before {
  }


  .drag_container {
  }
</style>



// WEBPACK FOOTER //
// src/components/microservice/task-editmenu.vue